import { mapGetters, mapActions} from 'vuex';
import mapper from '@/common/store/mapper/index.js';
import mvtNearby from '@/common/components/mvtnearby/mvt-nearby.vue';

export default {
    name: 'searchErrorBox',
    inject: ['$eventBus'],
    data: function() {
        return {
            forceHide: false,
            nearbyHomes: []
        };
    },
    components: {
        mvtNearby
    },
    methods: {
        ...mapActions('msp', ['getNearbyHomes']),
        close() {
            this.forceHide = true;
        },
        resetFilter() {
            this.$eventBus.$emit('eventbus-resetfilter');
        },
        goToSearchNearBy() {
            this.$eventBus.$emit('eventbus-expandsearch-nearby');
        },
        completed() {
          this.$refs['lazyload'].ready();
        },
    },
    computed: {
        ...mapGetters('msp', ['msp', 'getListings', 'getSearchCount', 'getIsSearching']),
        ...mapGetters('glb', ['viewport', 'glb', 'getSplit']),
        hasError() {
            if (this.getSearchCount) {
                if (this.forceHide || this.getIsSearching) {
                    this.forceHide = false;
                    return false;
                }
                const isError = this.isNoListings || this.isLastPage;
                if (isError) {
                    this.$eventBus.$emit('eventbus-nearbyHomes-msp', this.getParams);
                }
                return isError;
            }
        },
        listingData() {
          return this.nearbyHomes ? this.nearbyHomes.map(listing => mapper.property(listing, this.glb)) : null
        },
        isLastPage(){
            return this.msp && this.msp.firstPageIndex === this.msp.pageCount;
        },
        isNoListings(){
           return this.getListings && this.getListings.length === 0;
        },
        getLatLng(){
            if(this.msp && this.msp.currentSearchMode === this.msp.searchMode.coords){
                if(this.msp.filter && this.msp.filter.coordinates){
                    return this.msp.filter.coordinates.ne;
                }
            }
            return this.msp && this.msp.geo;
        },
        getParams(){
            const params = {
                lat: this.getLatLng.lat,
                lng: this.getLatLng.lng,
                rentals: !!this.msp.filter.rentals,
                count: this.msp.currentpageListings && this.msp.currentpageListings.length + 16,
                path: this.isNoListings ? '' : this.msp && this.msp.viewUrl
            }
            return params;
        }
    }
};
